export default __webpack_public_path__ + "static/media/card-project2.0f52156a.png";